export default "__VITE_ASSET__4a19dee9__"